import * as React from 'react';
import Grid from "@mui/material/Grid";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { TagStats } from "modules/insights";
import { ReportTypes } from "modules/reports/models";
import { DEFAULT_FIELD_WIDTH, DEFAULT_LABEL_WIDTH } from "modules/topics/styles/constants";
import { TopicReportHandler } from "modules/topics/utils/topicReportHandler";
import UserInsightsBlockInteract from "modules/users/components/userInsightsBlockInteract";
import HoverText from "modules/documents/components/action-buttons/hoverText";
import { TopicDetails } from "modules/topics/models";

const TopicInsights: React.FunctionComponent<ComponentProps> = (props) => {
    const FULL_ROW_WIDTH = DEFAULT_LABEL_WIDTH + DEFAULT_FIELD_WIDTH;

    const stats = props.stats;

    const handleReport = async (type: ReportTypes) => {
        const rh = new TopicReportHandler(props.topic.name, props.topic.id);
        await rh.requestReport(type);
        props.onReport();
    };

    const navigateTo = (page: string) => {
        const tenant = new URLSearchParams(window.location.search).get("tenant");
        window.open(`/${tenant}/admin/${page}?topics=${props.topic.id}&tabNum=3`, "_blank");
    };

    return (
        <Grid container spacing={0}>
            <Grid item xs={FULL_ROW_WIDTH / 3}>
                <UserInsightsBlockInteract
                    stats={`${stats.subscriberCount.toLocaleString()}`}
                    title={"Subscribers"}
                    handleClick={() => handleReport(ReportTypes.TopicSubscribersReport)}
                >

                    <FileDownloadOutlinedIcon />
                </UserInsightsBlockInteract>
            </Grid>

            <Grid item xs={FULL_ROW_WIDTH / 3}>

                <UserInsightsBlockInteract
                    stats={`${stats.authorCount.toLocaleString()}`}
                    title={
                        <HoverText label={"Authors"} labelContainerClassName="detail-label">
                            Number of Authors who can create content using this topic. This count does not include Owners.
                        </HoverText>
                    }
                    handleClick={() => handleReport(ReportTypes.TopicAuthorsReport)}>

                    <FileDownloadOutlinedIcon />
                </UserInsightsBlockInteract>
            </Grid>

            <Grid item xs={FULL_ROW_WIDTH / 3}>
                <UserInsightsBlockInteract
                    stats={`${stats.contributorCount.toLocaleString()}`}
                    title={
                        <HoverText label={"Contributors"} labelContainerClassName="detail-label">
                            Number of Contributors who can submit content using this topic.
                        </HoverText>
                    }
                    handleClick={() => handleReport(ReportTypes.TopicContributorsReport)}>

                    <FileDownloadOutlinedIcon />
                </UserInsightsBlockInteract>
            </Grid>

            <Grid item xs={FULL_ROW_WIDTH / 3}>
                <UserInsightsBlockInteract
                    stats={`${stats.viewCount.toLocaleString()}`}
                    title={
                        <HoverText label={"Views"} labelContainerClassName="detail-label">
                            Total views of posts and events that use this topic
                        </HoverText>
                    }
                    handleClick={() => navigateTo("insights")}>

                    <OpenInNewIcon />
                </UserInsightsBlockInteract>
            </Grid>

            <Grid item xs={FULL_ROW_WIDTH / 3}>
                <UserInsightsBlockInteract
                    stats={`${stats.postCount.toLocaleString()}`}
                    title={"Posts"}
                    handleClick={() => navigateTo("posts")}>

                    <OpenInNewIcon />
                </UserInsightsBlockInteract>
            </Grid>

            <Grid item xs={FULL_ROW_WIDTH / 3}>
                <UserInsightsBlockInteract
                    stats={`${stats.eventCount.toLocaleString()}`}
                    title={"Events"}
                    handleClick={() => navigateTo("events")}>

                    <OpenInNewIcon />
                </UserInsightsBlockInteract>
            </Grid>
        </Grid>
    );
};

interface ComponentProps {
    topic: TopicDetails,
    stats: TagStats,
    onReport: () => void,
}

export default TopicInsights;